import React from "react";

import {
  Box,
  Theme,
  Typography,
  TypographyProps,
  useMediaQuery,
} from "@mui/material";

export const HeroText: React.FC<
  TypographyProps<React.ElementType, { component?: React.ElementType }>
> = ({ children, component = "h1", ...defaultProps }) => {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.only("xs")
  );

  return (
    <Typography component={component}>
      <Box
        fontSize={isMobile ? 22 : 32}
        lineHeight={isMobile ? "28px" : "46.66px"}
        fontWeight={600}
        letterSpacing={0.5}
        component="span"
        display="block"
        {...defaultProps}
      >
        {children}
      </Box>
    </Typography>
  );
};
